import { render, staticRenderFns } from "./SpTab.vue?vue&type=template&id=6928cd16&scoped=true"
import script from "./SpTab.vue?vue&type=script&lang=ts"
export * from "./SpTab.vue?vue&type=script&lang=ts"
import style0 from "./SpTab.vue?vue&type=style&index=0&id=6928cd16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6928cd16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6928cd16')) {
      api.createRecord('6928cd16', component.options)
    } else {
      api.reload('6928cd16', component.options)
    }
    module.hot.accept("./SpTab.vue?vue&type=template&id=6928cd16&scoped=true", function () {
      api.rerender('6928cd16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/SpTab.vue"
export default component.exports